export const REDUX_NAMESPACE = 'MEDIA';
